import React from 'react';

import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useEditingHooks } from 'src/editor/helpers/useEditingHooks';
import { ClientTransforms } from 'src/editor/transforms';
import { useAuthorizedTransforms } from 'src/hooks';

import { GenericColorSelect } from '../shared/GenericColorSelect';

export function ParagraphColorSelect(): JSX.Element {
  const { AuthorizedTransforms } = useAuthorizedTransforms();
  const { currentUserId, editingMode, editor, editorLoading } = useEditingHooks();
  const fillColor = useEditorTabStateSelector(
    state => state.derived.paragraphProperties.shade?.fillColor
  );

  function selectParagraphColor(color: string | null): void {
    if (!currentUserId || !editingMode) return;

    AuthorizedTransforms.setParagraphProps(editor, editingMode, currentUserId, {
      shade: typeof color === 'string' ? { fillColor: color } : undefined,
    });
    ClientTransforms.focus(editor);
  }

  return (
    <GenericColorSelect
      color={fillColor ?? null}
      editorLoading={editorLoading}
      hasTransparentOption={true}
      iconType="fill"
      tooltipTitle="Paragraph fill color"
      onSelectColor={selectParagraphColor}
    />
  );
}
